const RECOMMENDED_FOR_YOU = 'recommendedForYou',
    OTHER_GIGS_BY = 'otherGigsBy',
    RECOMMENDED_IN_SUBCATEGORY = 'recommendedInSubCategory',
    RECENTLY_VIEWED = 'recentlyViewed',
    PERSONALIZED_CONTENT_RECOMMENDED_IN_SC = 'personalized_content_recommended_in_sc';

export { RECOMMENDED_FOR_YOU, OTHER_GIGS_BY, RECOMMENDED_IN_SUBCATEGORY, RECENTLY_VIEWED, PERSONALIZED_CONTENT_RECOMMENDED_IN_SC };
